import request from '@/utils/request';

/**
 * 确保 Privy 托管钱包 POL 手续费充足（不足时后端自动补发）
 * POST /liyuan-evm-pm/pm-chain/custodial/gas/ensure
 *
 * @param {{ walletAddress: string }} payload
 * @returns {Promise<{ sufficient?: boolean, action?: string, balancePol?: string }>}
 */
function postCustodialGasEnsure(payload = {}) {
  const walletAddress = String(payload.walletAddress ?? '').trim();
  if (!walletAddress) {
    return Promise.reject(new Error('walletAddress is required'));
  }
  return request.post('/liyuan-evm-pm/pm-chain/custodial/gas/ensure', { walletAddress });
}

function isGasSufficient(res) {
  if (res?.sufficient === true || res?.ensured === true) return true;
  return (
    String(res?.action ?? '')
      .trim()
      .toUpperCase() === 'SUFFICIENT'
  );
}

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * 调 ensure 并在补发进行中简单轮询，直到 sufficient 或达上限
 * @param {string} walletAddress
 * @param {{ maxAttempts?: number, delayMs?: number }} [options]
 */
export async function ensureCustodialGas(walletAddress, { maxAttempts = 3, delayMs = 2000 } = {}) {
  const addr = String(walletAddress ?? '').trim();
  if (!addr) return;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const res = await postCustodialGasEnsure({ walletAddress: addr });
    if (isGasSufficient(res)) return res;
    if (attempt < maxAttempts - 1) {
      await sleep(delayMs);
    }
  }
}
